import { render, staticRenderFns } from "./CohortSimulationPage.vue?vue&type=template&id=1bf839c4"
import script from "./CohortSimulationPage.vue?vue&type=script&lang=js"
export * from "./CohortSimulationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports